<template>
  <div class="app">
    <div class="app-content">
      <!-- Embedded, the host owns the app header, the page header and the footer. -->
      <t-upper-nav v-if="!embedded" />
      <main
        class="tw-overflow-y-aut tw-grow tw-shrink-0 tw-bg-primary-grey-25 tw-p-4 max-lg:tw-ml-14"
      >
        <div class="tw-w-full">
          <t-page-header
            v-if="!embedded"
            :product-links="productLinks"
            :user-links="userLinks"
            :data-test-id="'header-user-menu'"
          />
          <router-view />
        </div>
      </main>
      <cl-footer
        v-if="!embedded"
        :other-products-text="$t('other-products')"
        :try-now-text="$t('try-now')"
        :msp-name="getOrganisationBranding.name ?? undefined"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useAuthenticationStore } from "@/store/authentication.store";
import { isEmbedded } from "@/remote/contract";
import { storeToRefs } from "pinia";

import { useBrandingStore } from "@/store/branding.store";

import TPageHeader from "@/components/TPageHeader";
import TUpperNav from "@/components/TUpperNav/TUpperNav.vue";

import type {
  ProductLink,
  UserLink,
} from "@/components/TPageHeader/TPageHeader.types";

type SelectedMsp = {
  id?: string;
  name?: string;
  email?: string;
  roles?: string[];
  uuid?: string;
};

type SelectedAccount = {
  uuid?: string;
  name?: string;
  type_name?: string;
};

// Snapshotted once at boot by the contract module.
const embedded = isEmbedded();

const authStore = useAuthenticationStore();
const brandingStore = useBrandingStore();

const { organisationBranding: getOrganisationBranding } =
  storeToRefs(brandingStore);

const selectedMsp = computed((): SelectedMsp | null => authStore.selectedMsp);

const selectedAccount = computed(
  (): SelectedAccount | null => authStore.selectedAccount,
);

const productLinks: ProductLink[] = [];
const userLinks: UserLink[] = [];

onMounted(async () => {
  await brandingStore.getBranding({
    organisationUuid: selectedMsp.value?.uuid || selectedAccount.value?.uuid,
  });
});
</script>
